import { render, staticRenderFns } from "./navTip.vue?vue&type=template&id=f22db7f4&scoped=true"
import script from "./navTip.vue?vue&type=script&lang=js"
export * from "./navTip.vue?vue&type=script&lang=js"
import style0 from "./navTip.vue?vue&type=style&index=0&id=f22db7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22db7f4",
  null
  
)

export default component.exports